// extracted by mini-css-extract-plugin
module.exports = {"container":"FanfuryParticipationManual_container__2Bp07"};